export default {
  INIT_START: 'CONTAINERS/INIT_START',
  INIT_SUCCESS: 'CONTAINERS/INIT_SUCCESS',
  INIT_FAILURE: 'CONTAINERS/INIT_FAILURE',
  RESET: 'CONTAINERS/RESET'
};
